'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_model$package$IngredientId$() {
  this.a9O = 0;
  this.a9P = 0;
  $n_Lmealorama_model$package$IngredientId$ = this;
  $m_Lmealorama_model$package$IngredientId$();
  this.a9O = 0;
  this.a9P = 0;
}
export { $c_Lmealorama_model$package$IngredientId$ as $c_Lmealorama_model$package$IngredientId$ };
$p = $c_Lmealorama_model$package$IngredientId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_model$package$IngredientId$;
/** @constructor */
function $h_Lmealorama_model$package$IngredientId$() {
}
export { $h_Lmealorama_model$package$IngredientId$ as $h_Lmealorama_model$package$IngredientId$ };
$h_Lmealorama_model$package$IngredientId$.prototype = $p;
var $d_Lmealorama_model$package$IngredientId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_model$package$IngredientId$, "mealorama.model$package$IngredientId$", ({
  KQ: 1
}));
export { $d_Lmealorama_model$package$IngredientId$ as $d_Lmealorama_model$package$IngredientId$ };
var $n_Lmealorama_model$package$IngredientId$;
function $m_Lmealorama_model$package$IngredientId$() {
  if ((!$n_Lmealorama_model$package$IngredientId$)) {
    $n_Lmealorama_model$package$IngredientId$ = new $c_Lmealorama_model$package$IngredientId$();
  }
  return $n_Lmealorama_model$package$IngredientId$;
}
export { $m_Lmealorama_model$package$IngredientId$ as $m_Lmealorama_model$package$IngredientId$ };
//# sourceMappingURL=mealorama.model$package$-Ingredient-Id$.js.map
